import {
  EVALUATION_BACK_FAIL,
  EVALUATION_BACK_SUCCESS,
  EVALUATION_SELECT_FAIL,
  EVALUATION_SELECT_SUCCESS,
  INIT_FAIL,
  INIT_SUCCESS
} from "../actions/webEvaluation1";

const initialState = {
  itemName: null,
  categoryName: null,
  grade: null,
  gradeRange: null,
  classNumber: null,
  number: null,
  name: null,
  title: null,
  imageE: null,
  imageD: null,
  imageC: null,
  imageB: null,
  imageA: null,
  imageS: null,
  itemId: null
};

const webEvaluation1 = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case INIT_SUCCESS:
      return {
        ...state,
        itemName: payload.itemName,
        categoryName: payload.categoryName,
        grade: payload.grade,
        gradeRange: payload.gradeRange,
        classNumber: payload.classNumber,
        number: payload.number,
        name: payload.name,
        title: payload.title,
        imageE: payload.imageE,
        imageD: payload.imageD,
        imageC: payload.imageC,
        imageB: payload.imageB,
        imageA: payload.imageA,
        imageS: payload.imageS,
        itemId: payload.itemId
      };
    case EVALUATION_SELECT_SUCCESS:
      return {
        ...state,
        itemName: payload.itemName,
        categoryName: payload.categoryName,
        title: payload.title,
        imageE: payload.imageE,
        imageD: payload.imageD,
        imageC: payload.imageC,
        imageB: payload.imageB,
        imageA: payload.imageA,
        imageS: payload.imageS,
        itemId: payload.itemId
      };
    case EVALUATION_BACK_SUCCESS:
      return {
        ...state,
        itemName: payload.itemName,
        categoryName: payload.categoryName,
        title: payload.title,
        imageE: payload.imageE,
        imageD: payload.imageD,
        imageC: payload.imageC,
        imageB: payload.imageB,
        imageA: payload.imageA,
        imageS: payload.imageS,
        itemId: payload.itemId
      };
    case INIT_FAIL:
      return {
        ...state,
        error: payload.error
      };
    case EVALUATION_SELECT_FAIL:
      return {
        ...state,
        error: payload.error
      };
    case EVALUATION_BACK_FAIL:
      return {
        ...state,
        error: payload.error
      };
    default:
      return {
        ...state
      };
  }
};

export default webEvaluation1;
